<template lang="pug">
  #app
    alert-pop
    //transition(name="up", mode="out-in")
    component(:is="layout")
</template>

<script>
import PrivacyModal from '@/components/modals/PrivacyModal';
import AlertPop from '@/components/widgets/AlertPop';
import { mapState, mapGetters, mapActions } from 'vuex';
import LayoutApp from '@/components/layout/LayoutApp';
import LayoutService from '@/components/layout/LayoutService';
import LayoutFull from '@/components/layout/LayoutFull';

export default {
  name: 'App',
  components: {
    PrivacyModal,
    AlertPop,
    'layout-service': LayoutService,
    'layout-full': LayoutFull,
    'layout-app': LayoutApp,
  },
  computed: {
    ...mapState('service', ['config']),
    ...mapGetters('layout', ['layout']),
  },
  methods: {
    ...mapActions('resource', ['updateState']),
  },
  created() {
    this.updateState();
  },
};
</script>

<style lang="scss">
  body,
  html {
    width: 100%;
    height: 100%;
    // overflow: hidden;
  }
  #app{
    height: 100%;
    // background-color: $primary;
    // overflow: hidden;
    .cover {
      z-index: 1000;
      background-color: white;
      position: fixed;
      width: 100vw;
      height: 100vh;
      left: 0;
      top: 0;
    }
  }

  .up-enter-active, .page-leave-active {
    transition: transform 0.4s;
    overflow: hidden;
  }
  .up-enter {
    transform: translateY(100%);
  }

  // .page-enter-to {
  //   transform: translateX(0%);
  // }

  .up-leave-to {
    transform: translateY(-100%);
  }

</style>



// WEBPACK FOOTER //
// src/App.vue